import { DataBaseComponent } from "./data-base-component";
import { isNumber } from "@bonusmap/shared_ui/library";

export class DataOrganizationComponent extends DataBaseComponent {
    static webComponentName: string = "data-organization";
    protected _templateId: string = "data-organization";
    get value(): any {
        const v = super.value;
        if (typeof v === 'number') {
            return v;
        }
        if (typeof v === 'string') {
            const n = parseInt(v);
            if (isNumber(n)) {
                return n;
            }
        }
        return this.loggedOrganizationId||0;
        // return null;
    }
    set value(val: any) {
        
        super.value = val;
    }

    constructor() {
        super();
        this.setupGlobalListeners();

    }
    setupGlobalListeners(): void {
        // eventi globali delegati
        // This method can be overridden by subclasses to set up event listeners

    }

    setupEventListeners(): void {

    }
    public get rowId(): number {
        const dataCollector = this.querySelector("data-base-collector");
        if (dataCollector && 'rowId' in dataCollector) {
            return (dataCollector as any).rowId;
        }
        return 0;
    }

    afterRender(): void {
        if(!this.isSuperAdmin && this.dataSlotElement) {
             this.dataSlotElement?.classList.add('d-none');
        }
        super.afterRender();
        console.log(this.dataSlotElement?.key , this.dataSlotElement.field.value);
    }

    orgName(id: any): string {
        if (id === null || id === undefined) return 'N/A';
        if (isNumber(id)) id = Number(id);
        if (!id) return 'Tutte le organizzazioni';
        if (window.organizationsList && Array.isArray(window.organizationsList)) {
            const org = window.organizationsList.find(o => o.id === id);
            return org ? org.name : `Organizzazione #${id}`;
        }
        return `Organizzazione #${id}`;
    }
    addDataForTemplate(): Record<string, any> {
        console.log('this.loggedOrganizationId',this.loggedOrganizationId);
        return {
            isAdmin: this.isAdmin,
            isSuperAdmin: this.isSuperAdmin,
            valueSetted: (this.value !== null && this.value !== undefined && this.value !== ""),
            isValid: this.loggedOrganizationId && this.loggedOrganizationId >= 0,
            loggedOrganizationId: this.loggedOrganizationId,
            loggedOrganizationName: this.loggedOrganizationName,
            orgName: this.orgName(this.value),
        };
    }
}
